import styled from 'styled-components';

export const ScBonusCardTimer = styled.div`
  font-size: 12px;
  line-height: 18px;
  width: 100%;
`;
